module.exports = __webpack_public_path__ + "static/media/send-out.ca886f5a.svg";